import React from 'react';

interface IFakeCardsProps {
	arraySize: number;
	className?: string;
	rowSize: number;
}

export const RowFiller: React.FC<IFakeCardsProps> = ({
	arraySize,
	className,
	rowSize,
}) => (
	<>
		{arraySize % rowSize !== 0 &&
			[...Array(rowSize - (arraySize % rowSize))].map((_, key) => (
				<div key={key} className={className} />
			))}
	</>
);
